import { generateMetadata, MetaDataEntity } from './utils'

const MetaData: MetaDataEntity = {
  title: 'AviaGames | Fun, Thrilling, Competitive Free Mobile Games',
  description:
    'Enjoy fun, thrilling, competitive free mobile games with Avia. Play now for excitement & an opportunity to win real rewards!',
  keywords: ['free mobile games'],
  path: '',
}

export const HomeMetaData = generateMetadata(MetaData)
